import { useState, Dispatch, SetStateAction } from 'react';
import { useRefCallback } from './useRefCallback';


/**
 * Hook that handles state but only allows the state to changes once per delayMs time
 * @param initialValue - The value to start the state with (func or value)
 * @param delayMs - The delay in milliseconds to throttle the state change
 */
export const useThrottleState = <S>(
  initialValue: S | (() => S),
  delayMs?: number,
): [S, Dispatch<SetStateAction<S>>] => {
  const [state, setState] = useState(initialValue);
  const [canChange, setCanChange] = useState(true);

  const setStateThrottled = useRefCallback((newState: S | (() => S)) => {
    if (!canChange) {
      return;
    }

    setState(newState);
    setCanChange(false);
    setTimeout(() =>  setCanChange(true), delayMs || 0);
  });

  return [state, setStateThrottled];
}
